import axios from 'axios';

const API_BASE_URL = process.env.NODE_ENV === 'development' ? '/vision-api' : 'https://api.playground.ink/api';

export const getCollectionByOwner = async (collectionOwner: string) => {
    const response = await axios.post(`${API_BASE_URL}/getCollectionsByOwner`, {
        collectionOwner
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
    console.log(response);
    return response.data;
};

export const getTokenIdsByCollection = async (collection_owner: string): Promise<string[]> => {
    const response = await axios.post(`${API_BASE_URL}/getTokenIdsByCollection`, {
        collectionOwner: collection_owner
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
    // Extract just the token_id values from the array of objects
    return response.data.tokenIds.map((item: any) => item.token_id);
};

export const mint = async (collection_owner: string, collection_ref: number, wallet: string) => {
    const response = await axios.post(`${API_BASE_URL}/mint`, {
        collectionOwner: collection_owner,
        id : collection_ref,
        publicKey : wallet
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
};


export const finalize = async ( id:number, collectionOwner: string, placeholderMint: string, publicKey:string) => {
    const response = await axios.post(`${API_BASE_URL}/finalize`, {
        id,
        collectionOwner,
        publicKey,
        placeholderMint
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
};

export const claim = async (collectionOwner: string, publicKey: string) => {
    const response = await axios.post(`${API_BASE_URL}/claim`, {
        collectionOwner,
        publicKey
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
};

export const getClaims = async (collectionOwner: string, publicKey: string) => {
    const response = await axios.post(`${API_BASE_URL}/getClaims`, {
        collectionOwner,
        publicKey
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
};
